import { Breadcrumb } from '@fukuri-admins/ui/common';
import { formatDate } from '@fukuri-admins/utils/common/date';
import { useStressAssessmentReportBreadcrumb } from '~/usecases/useStressAssessmentReportBreadcrumb';
import { ROUTES } from '~/utils/routes';

type Props = {
  stressAssessmentId: number;
};

export const StressAssessmentReportBreadcrumb: React.FC<Props> = ({ stressAssessmentId }) => {
  const { data } = useStressAssessmentReportBreadcrumb({ stressAssessmentId });
  if (!data) return null;

  const stressAssessment = data.stress_assessment_summary?.stress_assessment;
  const surveyDateLabel = stressAssessment?.survey_date
    ? formatDate({
        date: new Date(stressAssessment.survey_date * 1000),
        formatType: 'yyyy/M/d',
      })
    : 'レポート';

  const items = [
    { label: 'ストレスチェック', href: ROUTES.STRESS_ASSESSMENTS.INDEX },
    {
      label: surveyDateLabel,
    },
  ];

  return <Breadcrumb items={items} />;
};
